module.exports = __webpack_public_path__ + "static/hospital_support_profile2@2x-e860dc258147e4af41f84f3bf5749464.png";